// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"5d49af6a","304":"d67af003","617":"0b578ce7","697":"6513f962","778":"128a111b","790":"082bfa70"}[chunkId] + ".chunk.js";
};